<template>
  <v-layout>
    <v-dialog v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1200px" lazy>
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="closeThisEval">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>MAPS</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-flex xs12>
            <v-layout row wrap>
              <div class="flex xs12 align-content-center text-xs-center">
                <canvas id="myCanvas" :width=canvasWidth :height=canvasHeight :style="background"/>
              </div>
            </v-layout>
          </v-flex>
          </v-card-text>
      </v-card>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-dialog>
  </v-layout>
</template>

<script>
// import Api from '@/services/Api'

export default {
  props: ['visible', 'item', 'location', 'boothNo', 'currentYear'],

  data () {
    return {
      page: 'list',
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      rows: [],
      editedItem: {},
      canvas: null,
      x: 0,
      y: 0,
      background: '',
      canvasWidth: 0,
      canvasHeight: 0
    }
  },

  created () {
    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getLocation()
    this.getBooths()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  watch: {
    boothNo: {
      // eslint-disable-next-line
      handler(newValue, oldValue) {
        if (this.location === 'South Hall 3') {
          this.background = 'background: url("' + process.env.API_URL + '/images/locations/newhall.png")'
          this.canvasWidth = 804
          this.canvasHeight = 1860
        } else if (this.location === 'Outside') {
          this.background = 'background: url("' + process.env.API_URL + '/images/locations/Outside1.png")'
          this.canvasWidth = 980
          this.canvasHeight = 2100
        } else if (this.location === 'South Lot 2') {
          this.background = 'background: url("' + process.env.API_URL + '/images/locations/SouthLot2a.png")'
          this.canvasWidth = 980
          this.canvasHeight = 924
        } else {
          this.background = 'background: url("' + process.env.API_URL + '/images/locations/Western_Hall2.png")'
          this.canvasWidth = 980
          this.canvasHeight = 1400
        }

        this.getBooths()
      },
      deep: true
    }
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    getLocation () {
      if (this.location === 'South Hall 3') {
        this.background = 'background: url("' + process.env.API_URL + '/images/locations/newhall.png")'
        this.canvasWidth = 804
        this.canvasHeight = 1860
      } else if (this.location === 'Outside') {
        this.background = 'background: url("' + process.env.API_URL + '/images/locations/Outside1.png")'
        this.canvasWidth = 980
        this.canvasHeight = 2100
      } else if (this.location === 'South Lot 2') {
        this.background = 'background: url("' + process.env.API_URL + '/images/locations/SouthLot2a.png")'
        this.canvasWidth = 980
        this.canvasHeight = 924
      } else {
        this.background = 'background: url("' + process.env.API_URL + '/images/locations/Western_Hall2.png")'
        this.canvasWidth = 980
        this.canvasHeight = 1400
      }
    },

    async getBooths () {
      try {
        console.log('year', this.currentYear)
        console.log('location', this.location)
        console.log('test')
        // this.vueCanvas.lineWidth = 1
        // this.vueCanvas.strokeStyle = 'black'

        // const response = await Api().get('extern_vendor_location/' + this.currentYear + '/' + this.location)

        // console.log('booths', response.data)
        // const booths = response.data

        // for (let i in booths) {
        //   let color = 'Silver'
        //   let abbrev = ''
        //   booths[i].abbrev = abbrev

        //   if (booths[i].VendorCompanyId > 0) {
        //     let vendor = booths[i].VendorCompany
        //     abbrev = vendor.abbrev
        //     color = 'IndianRed'

        //     let grandTotal = 0

        //     if (grandTotal <= 0) {
        //       color = 'SeaGreen'
        //     }
        //   }

        //   if (booths[i].type === 'poly') {
        //     if (booths[i].combine === 'No') {
        //       let poly = booths[i].poly.replace(/\s/g, '').split(',')
        //       this.vueCanvas.fillStyle = color

        //       this.vueCanvas.beginPath()
        //       this.vueCanvas.moveTo(poly[0], poly[1])

        //       for (let item = 2; item < poly.length - 1; item += 2) {
        //         this.vueCanvas.lineTo(poly[item], poly[item + 1])
        //         this.vueCanvas.stroke()
        //       }

        //       this.vueCanvas.closePath()
        //       this.vueCanvas.stroke()
        //       this.vueCanvas.fill()
        //       this.vueCanvas.font = '12px Arial'
        //       this.vueCanvas.textAlign = 'center'
        //       this.vueCanvas.textBaseline = 'middle'
        //       this.vueCanvas.fillStyle = '#000'
        //       this.vueCanvas.fillText(booths[i].boothNumber, booths[i].coor1 + (booths[i].coor3 / 2), booths[i].coor2 + (booths[i].coor4 / 2 - 5))
        //       this.vueCanvas.fillText(abbrev, booths[i].coor1 + (booths[i].coor3 / 2), booths[i].coor2 + (booths[i].coor4 / 2 + 10))
        //       console.log(booths[i].boothNumber)
        //     }
        //   } else {
        //     this.vueCanvas.beginPath()
        //     this.vueCanvas.rect(booths[i].coor1, booths[i].coor2, booths[i].coor3, booths[i].coor4)
        //     this.vueCanvas.fillStyle = color
        //     this.vueCanvas.fill()
        //     this.vueCanvas.stroke()
        //     this.vueCanvas.font = '12px Arial'
        //     this.vueCanvas.textAlign = 'center'
        //     this.vueCanvas.textBaseline = 'middle'
        //     this.vueCanvas.fillStyle = '#000'
        //     this.vueCanvas.fillText(booths[i].boothNumber, booths[i].coor1 + (booths[i].coor3 / 2), booths[i].coor2 + (booths[i].coor4 / 2 - 5))
        //     this.vueCanvas.fillText(abbrev, booths[i].coor1 + (booths[i].coor3 / 2), booths[i].coor2 + (booths[i].coor4 / 2 + 10))
        //     console.log(booths[i].boothNumber)
        //   }
        // }

        // console.log(this.currentYear, booths)

        // this.rows = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    closeThisEval (item) {
      this.dialog = false
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.showEmailForm = false
      this.showEvalForm = false
      this.show = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/vendorExtern/Maps.vue